import React from 'react'
import classNames from 'classnames'

import { IProps } from './index'
import { Text } from 'marketing-site/src/library/elements/Text'
import { RichText } from 'marketing-site/src/mvp/library/elements/RichText'
import styles from './styles.module.scss'

export const HeadingBase: React.FC<IProps> = ({
  brand,
  theme = 'none',
  width = 'default',
  alignment = 'center',
  icon,
  eyebrow,
  title,
  titleSize = 'heading-2',
  subhead,
  subheadSize,
  listStyle,
  ctas,
  footnote,
}) => {
  const classes = classNames(styles['heading-base'], 'heading-base', 'grid-layout', {
    [styles[`heading-base--theme-${theme}`]]: theme !== 'none',
    [styles[`heading-base--align-${alignment}`]]: alignment,
    [styles[`heading-base--width-${width}`]]: width,
    [styles[`heading-base__${titleSize}`]]: titleSize,
  })

  return (
    <>
      <div className={classes} data-testid="heading-base">
        <div className={styles['heading-base__inner']}>
          {icon && <div className={styles['heading-base__icon']}>{icon}</div>}
          {eyebrow && (
            <div className={styles[`heading-base__eyebrow`]}>
              <Text brand={brand} size="eyebrow">
                {eyebrow}
              </Text>
            </div>
          )}
          {title && (
            <h2 className={styles[`heading-base__title`]}>
              <Text brand={brand} size={titleSize}>
                {title}
              </Text>
            </h2>
          )}
          {subhead && (
            <div className={styles[`heading-base__subhead`]}>
              <Text
                brand={brand}
                size={
                  subheadSize
                    ? subheadSize
                    : titleSize === 'heading-3'
                    ? 'subhead-sm'
                    : 'subhead-lg'
                }
              >
                {typeof subhead === 'string' ? (
                  subhead
                ) : (
                  <RichText document={subhead} listStyle={listStyle} />
                )}
              </Text>
            </div>
          )}
          {ctas && <div className={styles['heading-base__ctas']}>{ctas}</div>}
          {footnote && (
            <div className={styles['heading-base__footnote']}>
              <Text size="caption">
                <RichText document={footnote} />
              </Text>
            </div>
          )}
        </div>
        <div className={styles['heading-base__background']} />
      </div>
    </>
  )
}
